// File: config.idleTimer.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items for the idle timer.
// Other Contributors:

export const idleTimer = {
    tokenRefreshInterval: 20,   // in minutes
    timeoutRefreshInterval: 1,  // in minutes
    timeoutInterval: 60,        // in minutes
    warningTime: 5,             // in minutes
};